module.exports = __webpack_public_path__ + "static/media/model.2dc56d9d.glb";